export function capitalizeWord(str) {
    const [firstLetter, ...otherLetters] = str.toLowerCase();
    return [firstLetter.toUpperCase(), ...otherLetters].join('');
}

export function titleCase(str) {
    return str.toLowerCase().split(' ').map(capitalizeWord).join(' ');
}

export function camelCase(str) {
    const [firstLetter, ...otherLetters] = str.trim().replace(/ /g, '');
    return [firstLetter.toLowerCase(), ...otherLetters].join('');
}
